import { useMutation } from '@tanstack/react-query';

import { deleteUnitMapping } from './deleteUnitMapping';
import {
  type DeleteUnitMappingMutationOptions,
  type DeleteUnitMappingPayload,
} from './types';

/**
 * Custom hook for deleting an existing unit mapping.
 *
 * @returns {Object} An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Units/operation/delete_unit_mapping_units_unit_mapping__id__delete
 */
export const useMutationDeleteUnitMapping = (
  options?: DeleteUnitMappingMutationOptions,
) => {
  return useMutation({
    mutationFn: async (unitMappingId: DeleteUnitMappingPayload) =>
      deleteUnitMapping(unitMappingId),
    ...options,
  });
};
